import { jwtDecode } from 'jwt-decode'
import { extractCookie } from 'lib/web/cookieUtils'

interface OtpClaims {
  otp_verified?: boolean
  otp_verification?: number // timestamp
}

interface OtpVerificationParams {
  expirationThreshold?: number
  token?: string
}

/**
 * Checks if the user has been OTP verified within the last day
 * by examining the JWT access_token claims
 * @returns true if OTP verified and verification is not expired
 */
export function isOtpVerified(options: OtpVerificationParams): boolean {
  try {
    const accessToken = options.token ?? extractCookie(document.cookie, 'ssr_access_token')
    if (!accessToken) {
      return false
    }
    const decoded = jwtDecode<OtpClaims>(accessToken)

    // Check if otp_verified claim is true
    if (!decoded.otp_verified) {
      return false
    }

    // Check if otp_verification timestamp exists
    if (!decoded.otp_verification) {
      return false
    }

    // and check if the otp verification has not expired
    if (options.expirationThreshold !== undefined) {
      const verificationTime = decoded.otp_verification * 1000 // Convert to milliseconds
      const now = Date.now()
      const timeSinceVerification = now - verificationTime

      return timeSinceVerification < options.expirationThreshold
    }
    return true
  } catch {
    // If we can't decode the token, assume not verified
    return false
  }
}
